import React from "react";

export const PaymentAccountDetailContext = React.createContext(null);

export const usePaymentAccountDetailContext = () => {
  const context = React.useContext(PaymentAccountDetailContext);

  if (!context) throw new Error("Payment Account Detail Context not provided!");

  return context;
};
